module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    staticClass: "mr-1 element-button elevation-0",
    attrs: {
      "fab": "",
      "small": "",
      "color": _vm.buttonClass
    },
    on: {
      "click": _vm.showDialog
    }
  }, [(_vm.linkedFileCount) ? _c('v-badge', [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.linkedFileCount))]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "color": "blue darken-1"
    }
  }, [_vm._v("attach_file")])], 1) : _c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("attach_file")])], 1), _vm._v(" "), _c('FileDialog', {
    attrs: {
      "element": _vm.element,
      "files": _vm.files,
      "settings": _vm.fileDialog.settings
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-112d41ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/UploadElement.vue
// module id = 2454
// module chunks = 1